module.exports = __webpack_public_path__ + "static/media/CleopatrasWorldwide.4622127b.mov";